<style lang="less">
    @import './403.less';
</style>

<template>
    <div class="error403">
        <div class="error403-body-con">
            <Card>
                <div class="error403-body-con-title">4<span class="error403-0-span"><Icon type="android-lock"></Icon></span>3
                    <!--<span class="error403-key-span">-->
                        <!--<Icon size="220" type="ios-bolt"></Icon>-->
                    <!--</span>-->
                </div>
                <p class="error403-body-con-message">You don't have permission</p>
                <div class="error403-btn-con">
                    <a style="color: #636e72;font-weight: 500" href="https://www.diantiyun.com/">
                        <span class="forget">{{$t('l.remark174')}}</span>
                    </a>
                    <Button @click="backPage" size="large" style="width: 200px;margin-left: 40px;" type="primary">{{$t('l.remark175')}}</Button>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Error403',
    methods: {
        backPage () {
            this.$router.push({
                name: 'home_index'
            });
        },
        // goHome () {
        //
        // }
    }
};
</script>
